export const htmlToPlainText = (htmlText?: string, compactLength?: number): string => {
  return (htmlText || '')
    ?.replace(/<[^>]*>?/gm, ' ') // Replace HTML tags with spaces
    ?.replace(/\s+/g, ' ') // Replace multiple spaces with a single space
    ?.replace(/&nbsp;/g, ' ') // Replace non-breaking spaces with a space
    ?.trim() // Trim leading and trailing spaces
    ?.slice(0, compactLength) // Slice the text to the desired length
    ?.replace(/\s+\S*$/, ''); // Ensure words don't break
};
